/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const TransactionValueFormatter = (cellContent, row, rowIndex) => {
  const { transactionId } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {transactionId ? transactionId : "-"}
      </div>
      <> </>
    </>
  );
};
